// A11y props for a click-to-expand pw-table row (the shared "employee-row"
// pattern used by the Gross Income, Summary, and Manual Adjustments steps).
// A bare `<tr onClick>` is mouse-only: a keyboard/screen-reader user can't
// expand a row to reach the per-employee detail (incl. Adjustments' Edit/Delete,
// which live inside the expansion). Spreading these props makes the row a real
// keyboard control — focusable, Enter/Space toggles, state announced via
// aria-expanded — in one place so every step inherits it. (BL-013)
//
// We deliberately do NOT set role="button": that would replace the row's
// implicit `row` role and strip its <td> cells out of the table's a11y tree,
// costing screen-reader users the row/column context (a net a11y loss on an
// a11y fix — flagged in impl-review). aria-expanded is valid on a table row,
// so keeping the native role + tabIndex + key handler is the better trade.
//
// Usage: <tr className="employee-row …" {...expandableRowProps(isExpanded, toggle)}>
// where `toggle` is the row's existing expand/collapse callback.
export function expandableRowProps(isExpanded, toggle) {
  return {
    tabIndex: 0,
    "aria-expanded": isExpanded,
    onClick: toggle,
    onKeyDown: (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault(); // Space would otherwise scroll the page
        toggle();
      }
    },
  };
}
